export default __webpack_public_path__ + "static/media/check_enabled.7872711f.svg";